// @flow
import * as React from 'react';

import styles from './HR.module.scss';;


const HR = () => (
  <hr className={styles.root} />
);

export default HR;
